import { React, useState } from "react";
import { CiPlay1 } from "react-icons/ci";
import { useParams } from "react-router-dom";

import RenderNestedServicesWithForms from "./RenderNestedServicesWithForms";
// made for the service button in the services page option bar , may be reused later in other pages else should be renamed to servicebutton/link
function OptionBarServiceButtonWithForms({
  option,
  icon,
  forms,
  showInactive,
}) {
  const combinedForms = [
    ...option.offlineForms,
    ...option.ddiForms,
    ...option.callLineForms,
  ];

  // console.log(service);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
    // console.log("params: ", params )
    // console.log("option: ", option)
  };
  const params = useParams();
  // useEffect(() => {
  //   if(params.id && (params.id === option.serviceId)){
  //     setIsOpen(true)
  //     console.log("setting open to true in this option " , option)
  //   }
  // }, []);
  return (
    <li key={option.serviceId}>
      <div className="d-flex align-items-baseline gap-1">
        {(option.subServices && option.subServices.length > 0) ||
        (combinedForms != undefined && combinedForms.length > 0) ? (
          <p
            className={`list-arrow ${isOpen ? "is-open" : ""}`}
            onClick={handleClick}
          >
            {<CiPlay1 size={12} />}
          </p>
        ) : (
          <p className={"hidden-arrow"}>{<CiPlay1 size={12} />}</p>
        )}

        <p className={`nested-list-item `}>
          {icon} {option.name}
        </p>
      </div>
      {((option.subServices && option.subServices.length > 0) ||
        (combinedForms != undefined && combinedForms.length > 0)) && (
        <RenderNestedServicesWithForms
          showInactive={showInactive}
          isOpen={isOpen}
          options={option.subServices}
          forms={combinedForms}
          icon={icon}
        />
      )}
    </li>
  );
}

export default OptionBarServiceButtonWithForms;
